<template>
  <main class="customer_join main">
    <div class="join_inner">
      <div class="text_area">
        <h2>연령대를<br />선택해 주세요!</h2>
        <p>내 또래들은 주로 어떤 상품을 이용할까요?</p>
      </div>
      <div class="join_age">
        <ul>
          <li v-for="(item, index) in userAgeRange" :key="index">
            <button @click="joinAgeSel(item.value)">{{ item.label }}</button>
          </li>
        </ul>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: 'JoinAge',
  components: {},
  data() {
    return {
      userAgeRange: [
        { label: '10대', value: 'AGE_15_19' },
        { label: '20대', value: 'AGE_20_29' },
        { label: '30대', value: 'AGE_30_39' },
        { label: '40대', value: 'AGE_40_49' },
        { label: '50대', value: 'AGE_50_59' },
        { label: '60대', value: 'AGE_60_69' },
        { label: '70대 이상', value: 'AGE_70_ABOVE' },
      ],
    };
  },
  created() {},
  async mounted() {},
  computed: {},
  methods: {
    joinAgeSel(age) {
      localStorage.setItem('join_age', age);

      this.$router.push({
        name: 'Auth.JoinRegion',
      });
    },
  },
};
</script>
